import {setButtonBusyState, unsetButtonBusyState} from "./spinners.js";
import {showValidationErrors} from "../../../admin/script/util/errors.js";
import {httpPost} from "../../util/http.js";

export class RegisterWrForm {

    constructor({$form, ...props}) {
        this.props = props;
        this.$form = $form;
        this.$form.on('click', 'button[type="submit"]', e => {
            e.preventDefault();
            this.submit({
                $button: jQuery(e.target),
            });
        });
        this.$form.on('submit', e => {
            e.preventDefault();
            this.submit({
                $button: this.$form.find('button[type="submit"]'),
            });
        });
    }

    async submit(options = {}) {
        const $button = options.$button;
        const $registerFormElements = this.$form.find('.register-form-element');
        const data = {
            ...(options.data || {}),
            ...(this.props.data || {}),
        };

        $registerFormElements.each((i, element) => {
            if (element.name) {
                data[element.name] = element.value;
            }
        });
        this.hideErrors();

        data.rules = this.$form.find('input[name="rules"]').prop('checked');
        data.process_person_data = this.$form.find('input[name="process_person_data"]').prop('checked');
        data.marketing_consent = this.$form.find('input[name="marketing_consent"]').prop('checked');
        data.hash_s = this.props.hash_s;
        data.hash = this.props.hash;
        setButtonBusyState($button);

        try {
            const response = await httpPost(POLKURIER.paths.get('without_registration_new_account_register'), data);
            this.hideErrors();
            showValidationErrors(this.$form, {});
            this.$form.parent().find('#idaccount').html(response.idaccount);
            this.$form.parent().find('#registration-form-final-div').removeClass('d-none');
            this.$form.remove();
        } catch (response) {
            this.showError(response.message || response.responseJSON.errors || 'Formularz zawiera błędy');
            if (response.responseJSON.data && response.responseJSON.data.fieldsErrors) {
                showValidationErrors(this.$form, response.responseJSON.data.fieldsErrors);
            }
        }
        unsetButtonBusyState($button);
    }

    hideErrors() {
        this.$form.find('.is-invalid').removeClass('is-invalid');
        this.$form.find('.errors-container').hide();
    }

    showError(message) {
        this.$form.find('.errors-container')
            .empty()
            .show()
            .append([
                jQuery('<div>', {class: 'alert alert-danger text-center mb-3'})
                    .append([
                        message,
                    ]),
            ]);
    }

}
